import { Reducer } from 'redux';
import deepmerge from 'deepmerge';
import { ConfigActionTypes } from './types';
import { defaultUniConfig } from 'configuration-data';
import { ISystemAndUniConfig } from 'api-paths-cas';
import { IConfigState } from '@/types';

const defaultConfig = JSON.parse(JSON.stringify(defaultUniConfig ?? {})) as ISystemAndUniConfig;

const initialState: IConfigState = {
  ...defaultConfig,
  isLoaded: false,
  regionInterviewConfig: [],
  pathwayPartnerConfig: {},
  scholarships: [],
  featureFlags: {},
  admAllowedAliases: [],
};

const reducer: Reducer<IConfigState> = (state = initialState, action) => {
  switch (action.type) {
    case ConfigActionTypes.GET_UNI_CONFIG:
      return {
        ...state,
        isLoaded: false,
      };
    case ConfigActionTypes.GET_UNI_CONFIG_SUCCESS:
      let uniConfig: any = action.payload || {};

      const overwriteMerge = (_: [], sourceArray: []) => sourceArray;
      uniConfig = deepmerge(defaultConfig, uniConfig, {
        arrayMerge: overwriteMerge,
      });
      return {
        ...uniConfig,
        featureFlags: state.featureFlags,
        navigationUrls: state.navigationUrls,
        admAllowedAliases: state.admAllowedAliases, // Preserve ADM aliases
        isLoaded: true,
      };
    case ConfigActionTypes.SAVE_CALENDLY_CONFIG_SUCCESS: {
      return {
        ...state,
        CalendlyConfig: action.payload.CalendlyConfig,
      };
    }
    case ConfigActionTypes.GET_UNI_REGION_INTERVIEW_CONFIG_SUCCESS: {
      const regionInterviewConfig: any = action.payload || [];
      return {
        ...state,
        regionInterviewConfig,
      };
    }
    case ConfigActionTypes.GET_PARTNER_CONFIG_BY_NAME: {
      return {
        ...state,
        isLoading: true,
        isSaveSuccess: false,
      };
    }

    case ConfigActionTypes.GET_PARTNER_CONFIG_BY_NAME_SUCCESS: {
      return {
        ...state,
        pathwayPartnerConfig: action.payload.config,
        isLoading: false,
      };
    }
    case ConfigActionTypes.GET_PARTNER_CONFIG_BY_NAME_FAILURE: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case ConfigActionTypes.GET_NAVIGATION_URLS_SUCCESS: {
      return {
        ...state,
        navigationUrls: action.payload,
      };
    }
    case ConfigActionTypes.GET_NAVIGATION_URLS_FAILURE: {
      return {
        ...state,
        navigationUrls: undefined,
      };
    }
    case ConfigActionTypes.GET_FEATURE_FLAGS_DATA_SUCCESS: {
      return {
        ...state,
        featureFlags: action.payload.featureFlags,
      };
    }

    case ConfigActionTypes.GET_ADM_ALLOWED_ALIASES_SUCCESS: {
      return {
        ...state,
        admAllowedAliases: action.payload,
      };
    }

    case ConfigActionTypes.GET_ADM_ALLOWED_ALIASES_FAILURE: {
      // Silently fail - ADM aliases are a nice-to-have feature
      return state;
    }

    default: {
      return state;
    }
  }
};

export { reducer as configReducer };
